import { render, staticRenderFns } from "./batch-management-subpage.vue?vue&type=template&id=40c3f83a&scoped=true&"
import script from "./batch-management-subpage.vue?vue&type=script&lang=js&"
export * from "./batch-management-subpage.vue?vue&type=script&lang=js&"
import style0 from "./batch-management-subpage.vue?vue&type=style&index=0&id=40c3f83a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c3f83a",
  null
  
)

export default component.exports